import { useCalibrationsQuery } from "@/shared/api";
import { useSchedules } from "./useSchedules";

export function useCalibration() {
  const { activeSchedule: calibrationActiveSchedule } = useSchedules({
    queryKey: "calibrationSchedules",
  });
  const { calibration } = useCalibrationsQuery(
    {
      calibrationId: calibrationActiveSchedule?.id ?? 0,
    },
    {
      skip: !calibrationActiveSchedule,
      selectFromResult: (result) => ({
        calibration: result.data?.result,
      }),
    }
  );

  return { calibration, calibrationActiveSchedule };
}
